<template>
  <Modal v-if="start && end"
         :isOpen="isOpen"
         :withoutTemplate="true"
         :close="() => $emit('close')"
  >
    <With_Header_Modal_Template title="Выбор места" width="712px" :emitClose="true" @close="$emit('close')">
      <preload-content :loading="!workplaces" min-height="60vh">
        <div class="place" v-if="workplaces">
          <div>
            <svg id="root" class="apartments-b-house svg-content" width="712" height="650" viewBox="0 0 712 650" preserveAspectRatio="xMinYMin meet">
              <use id="Фон" xlink:href="#_Image1" x="0" y="0" width="100%" height="100%"/>
              <g v-for="workplace in workplaces" :key="workplace.id"
                 @click="setSelectWorkplace(workplace)"
                 v-html="getWorkplaceHtml(workplace)"
                 class="workplace"
                 :class="{selected: isSelected(workplace.id)}"
              >
              </g>
              <defs>
                <image id="_Image1" :xlink:href="background"/>
              </defs>
            </svg>
            <div class="bottom" v-if="zones">
              <div class="bottom__item" v-for="zone in zones" :key="zone.id">
                <div class="circle" :style="{'background-color': zone.color}"></div>
                <span>{{ zone.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </preload-content>
      <button slot="footer" @click="$emit('submit')" :disabled="!isSelectedWorkplaces">Сохранить</button>
    </With_Header_Modal_Template>
  </Modal>
</template>

<script>
import PreloadContent from '@/components/ui/preload-content';
import Modal from '@/components/functional/Modal'
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import moment from "moment";

export default {
  name: "Calendar_Place_Chose_Modal",
  components: {With_Header_Modal_Template, Modal, PreloadContent},
  props: [
    'isOpen',
    'background',
    'chosenSvg',
    'chosenBackground',
    'chosenCircle',
    'overflow',
    'coworkingId',
    'zoneId',
    'id',
    'zones',
    'start',
    'end'
  ],
  data() {
    return {
      workplaces: null,
    }
  },
  computed: {
    isSelectedWorkplaces() {
      return this.chosenCircle && this.chosenCircle.length;
    },
    available_start_at() {
      return this.start ? this.$moment(this.start).format('YYYY-MM-DD HH:mm:ss') : null;
    },
    available_end_at() {
      return this.end ? this.$moment(this.end).format('YYYY-MM-DD HH:mm:ss') : null;
    },
  },
  mounted() {
    this.$api.coworking.zone.workplace.list(this.coworkingId, this.zoneId, {
      available_start_at: this.available_start_at,
      available_end_at: this.available_end_at,
    }).then(({data}) => {
      this.workplaces = data;
      if (!this.workplaces.length) this.loadAvailable();
    });
  },
  methods: {
    parseHTML(str) {
      var dom = document.createElement('div');
      dom.innerHTML = str;
      return dom.children[0];
    },
    getWorkplaceHtml(workplace) {
      let circle = this.parseHTML(workplace.path);
      return `${workplace.path}<text x="${circle.getAttribute('cx')}" y="${circle.getAttribute('cy')}"
              text-anchor="middle" stroke="#000" stroke-width="2px" dy=".3em">${workplace.number}</text>`;
    },
    loadAvailable() {
      this.$api.coworking.zone.workplace.available(this.coworkingId, this.zoneId, {
        available_start_at: this.available_start_at,
        available_end_at: this.available_end_at,
      }).then((data) => {
        if (!data.workplaces.length) return this.$toast.error('В выбранной зоне на ближайшие дни все места уже арендованы');
        this.$toast.warning(`К сожалению, все места заняты. Ближайшая свободная дата: ${moment(data.start).format('DD.MM.YYYY HH:mm')} - ${moment(data.end).format('DD.MM.YYYY HH:mm')}`);
      })
    },
    setSelectWorkplace(workplace) {
      this.$emit(this.isSelected(workplace.id) ? 'removeCircle' : 'choseCircle', workplace.id);
    },
    isSelected(id) {
      return this.chosenCircle.indexOf(id) !== -1;
    }
  }

}
</script>

<style scoped lang="scss">
.c_p {
  cursor: pointer;

  &:hover {
    opacity: .8;
  }
}

.place {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  div {
    width: 100%;
    height: 100%;
  }

  svg {
    width: auto;
    height: calc(100vh - 270px);
    max-height: 600px;
  }
}

.bottom {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 30px;

  div.bottom__item {
    width: auto;
    margin-right: 40px;
    display: flex;
    align-items: center;

    .circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
}

@media (max-width: 580px) {
  .place {
    svg {
      height: calc(100vw - 50px);
    }
  }
}

@media (max-width: 425px) {
  .place {
    svg {
      height: calc(100vw - 10px);
    }
  }
}

@media (max-width: 370px) {
  .place {
    svg {
      height: calc(100vw - 5px);
    }
  }
}

</style>

<style lang="scss">

.workplace {
  circle {
    transition: .5s;

    &:hover {
      cursor: pointer;
      fill: #000000;
    }
  }

  &.selected {
    circle {
      stroke: #000000;
      stroke-width: 1px;
    }
  }
}

.chosenCircle {
  position: relative;
  z-index: 99;

  circle {
    fill: #000000;
  }
}

.hoverable_circle {
  cursor: pointer;
}
</style>
